/* eslint-disable import/prefer-default-export */
export const languageConstants = {
  SET_LANGUAGE: 'LANGUAGES_SET_LANGUAGE',
  UNSET_LANGUAGE: 'LANGUAGES_UNSET_LANGUAGE',
};
